'use client';

import type { ReactNode } from 'react';

/**
 * Horizontal-scrolling row used by upcoming-classes, booking-categories,
 * coaches, etc. Snap, hidden scrollbar, consistent gutter.
 *
 * The horizontal indent lives on an outer wrapper rather than the scroll
 * container's own `padding-inline`, because padding inside an
 * `overflow-x: auto` flex parent gets clipped on the scroll axis in iOS
 * WebKit (the cards visually flush to the screen edge regardless of how
 * large `padding-left` is). The outer block is laid out before scroll
 * applies, so the indent always renders.
 */
export function HorizontalCardScroller({
  children,
  gap = 14,
  paddingX = 22,
}: {
  children: ReactNode;
  gap?: number;
  paddingX?: number;
}) {
  return (
    <div style={{ paddingInlineStart: paddingX, paddingInlineEnd: paddingX }}>
      <div
        style={{
          display: 'flex',
          gap,
          overflowX: 'auto',
          scrollSnapType: 'x mandatory',
          WebkitOverflowScrolling: 'touch',
          scrollbarWidth: 'none',
          paddingTop: 16,
          paddingBottom: 8,
        }}
        className="scrollbar-hide"
      >
        {children}
      </div>
    </div>
  );
}
